module.exports = __webpack_public_path__ + "img/GRFH.1274ffcb.jpg";